import { useTranslation } from 'react-i18next'

import { Card, Skeleton, Text } from '@mercai/clever'

import { formatCurrency } from '@/helpers'

import { CardShowTotalProps } from './card-show-total.type'

import styles from './card-show-total.module.css'

export const CardShowTotal = ({
  isLoading,
  totalWithoutIva,
  total,
  iva,
  dollarTotalWithoutIva,
  dollarTotal,
  dollarIva,
}: CardShowTotalProps) => {
  const { t } = useTranslation('screenOrderCenterPage')

  const Loading = () => {
    return (
      <Card className={styles.card}>
        <div className={styles['card-item']}>
          <div className={styles['align-left']}>
            <Text>{t('componentCardShowTotalSubtotalLabel')}</Text>
          </div>
          <div>
            <Text>
              <strong>
                <Skeleton height="1rem" width="5rem" />
              </strong>
            </Text>
          </div>
          <div>
            <Text>
              <strong>
                <Skeleton height="1rem" width="5rem" />
              </strong>
            </Text>
          </div>
        </div>

        <div className={styles['card-item']}>
          <div className={styles['align-left']}>
            <Text>{t('componentCardShowTotalIvaLabel')}</Text>
          </div>
          <div>
            <Text>
              <strong>
                <Skeleton height="1rem" width="5rem" />
              </strong>
            </Text>
          </div>
          <div>
            <Text>
              <strong>
                <Skeleton height="1rem" width="5rem" />
              </strong>
            </Text>
          </div>
        </div>

        <div className={styles['card-item-total']}>
          <div className={styles['align-left']}>
            <Text variant="title-medium">
              {t('componentCardShowTotalTotalLabel')}
            </Text>
          </div>
          <div>
            <Text variant="title-medium">
              <Skeleton height="1rem" width="5rem" />
            </Text>
          </div>
          <div>
            <Text variant="title-medium">
              <Skeleton height="1rem" width="5rem" />
            </Text>
          </div>
        </div>
      </Card>
    )
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <Card className={styles.card}>
      <div className={styles['card-item']}>
        <div className={styles['align-left']}>
          <Text>{t('componentCardShowTotalSubtotalLabel')}</Text>
        </div>
        <div>
          <Text>
            <strong>
              {formatCurrency(totalWithoutIva || 0, 'es-MX', 'MXN')}
            </strong>
          </Text>
        </div>
        <div>
          <Text>
            <strong>
              {formatCurrency(dollarTotalWithoutIva || 0, 'es-MX', 'USD')}
            </strong>
          </Text>
        </div>
      </div>

      <div className={styles['card-item']}>
        <div className={styles['align-left']}>
          <Text>{t('componentCardShowTotalIvaLabel')}</Text>
        </div>
        <div>
          <Text>
            <strong>{formatCurrency(iva || 0, 'es-MX', 'MXN')}</strong>
          </Text>
        </div>
        <div>
          <Text>
            <strong>{formatCurrency(dollarIva || 0, 'es-MX', 'USD')}</strong>
          </Text>
        </div>
      </div>

      <div className={styles['card-item-total']}>
        <div className={styles['align-left']}>
          <Text variant="title-medium">
            {t('componentCardShowTotalTotalLabel')}
          </Text>
        </div>
        <div>
          <Text variant="title-medium">
            {formatCurrency(total || 0, 'es-MX', 'MXN')}
          </Text>
        </div>
        <div>
          <Text variant="title-medium">
            {formatCurrency(dollarTotal || 0, 'es-MX', 'USD')}
          </Text>
        </div>
      </div>
    </Card>
  )
}
